import { norm, mesLabel } from "@/lib/todosDocs";

const v = (an, k) => an?.[k]?.valor ?? null;

// Nombre «técnico»: IMG_1234, scan0001, document(1), fic_impresion_…pdf, etc.
export const esTecnico = (name) => {
  const n = (name || "").trim();
  if (!n) return true;
  const base = n.replace(/\.(pdf|jpe?g|png|heic|webp)$/i, "");
  const PREF = "(img|dsc|dcim|scan|escaneo|doc|document|documento|fic|image|imagen|photo|foto|whatsapp|pdf|file|archivo)";
  if (new RegExp(`^${PREF}([\\s_\\-]*\\(?\\d+\\)?)?$`, "i").test(base)) return true;
  if (!/\s/.test(base) && new RegExp(`^${PREF}[_\\-]`, "i").test(base)) return true;
  if (/\(\d+\)$/.test(base) || /^(whatsapp image|screenshot|captura de pantalla)/i.test(base)) return true;
  const digitos = (base.match(/\d/g) || []).length;
  if (!/\s/.test(base) && (digitos >= 4 || (base.match(/_/g) || []).length >= 2)) return true;
  return n !== base && !/\s/.test(base);
};

export const nombrePropuesto = (doc) => {
  const an = doc?.analisis || {};
  const t = v(an, "titulo_sugerido");
  const p = v(an, "proveedor");
  const primera = norm(p).split(/[\s,]+/)[0] || "";
  if (t) return (p && !norm(t).includes(primera) ? `${t} · ${p}` : t).slice(0, 150);
  const tipo = v(an, "tipo_documento");
  const f = v(an, "fecha_documento");
  const mes = /^\d{4}-\d{2}/.test(f || "") ? f.slice(0, 7) : (doc?.created_at || "").slice(0, 7);
  const partes = [tipo, p, mes && mesLabel(mes)].filter(Boolean);
  return tipo || p ? partes.join(" · ").slice(0, 150) : "";
};
